import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import appInfo from './../../app-info';

export default function Footer() {
  return (
    <Box
      component='footer'
      sx={{
        textAlign: 'center',
        py: 3,
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
      }}
    >
      <Typography variant='body2' color='textSecondary'>
        © {appInfo.title} ({appInfo.version}) 2023-{new Date().getFullYear()}. |
        Weboldalt készítette:{' '}
        <Link
          href='https://laszloerno.hu'
          target='_blank'
          rel='noopener noreferrer'
        >
          László Ernő
        </Link>
      </Typography>
      <Typography variant='body2' color='textSecondary' sx={{ mt: 1 }}>
        Minden jog fenntartva. Az oldalon található szövegek, szövegrészletek,
        fotók, videók és grafikák a szerzői jog védelme alatt állnak. További
        felhasználásuk csak a szerző előzetes írásos beleegyezésével történhet.
      </Typography>
      <Box sx={{ mt: 1 }}>
        <Link
          href={process.env.PUBLIC_URL + '/aszf'}
          target='_blank'
          rel='noopener noreferrer'
          sx={{ mx: 1 }}
        >
          Általános Szerződési Feltételek
        </Link>
        |
        <Link
          href={process.env.PUBLIC_URL + '/gdpr'}
          target='_blank'
          rel='noopener noreferrer'
          sx={{ mx: 1 }}
        >
          Adatvédelmi Tájékoztató
        </Link>
      </Box>
      <Typography variant='body2' color='textSecondary' sx={{ mt: 2 }}>
        Weboldalunk a Barion© fizetési megoldását alkalmazza
      </Typography>
      <Box sx={{ mt: 1 }}>
        <img
          src={
            process.env.PUBLIC_URL + '/img/barion-card-strip-intl__medium.png'
          }
          alt='Barion Logo'
          style={{ height: 30 }}
        />
      </Box>
    </Box>
  );
}
